/**
* 采集原始数据
*/
const measuringRaw = {
  
getMeasuringRawValue: "/api/getMeasuringRawValue",//原始值查询
getMeasuringRawValue2: "/api/getMeasuringRawValue2",//查询所有瞬时数据
getLatestMeasuringRawValue: "/api/getLatestMeasuringRawValue",//最新原始值查询
getMeasuringRawValueHour: "/api/getMeasuringRawValueHour",//原始值查询
getMeasuringRawValueDay: "/api/getMeasuringRawValueDay",//原始值查询
getMeasuringRawValueMonth: "/api/getMeasuringRawValueMonth",//原始值查询
getMeasuringRawValueYear: "/api/getMeasuringRawValueYear",//原始值查询
getMeasuringRawValueHour2: "/api/getMeasuringRawValueHour2",//原始值查询
getMeasuringRawValueDay2: "/api/getMeasuringRawValueDay2",//原始值查询
getMeasuringRawValueMonth2: "/api/getMeasuringRawValueMonth2",//原始值查询
getMeasuringRawValueYear2: "/api/getMeasuringRawValueYear2",//原始值查询
}

export default measuringRaw